import React, { useRef } from 'react'
import { TableVirtualized } from '../../root/components/common/table-virtualized/table'
import { useSelector } from 'react-redux'
import { useTreeUtils } from '../../root/components/common/locations-tree/tree-utils'
import { LocationsTree } from '../../locations/components/locations-tree'
import { LocationsTreeNode } from '../../root/components/common/locations-tree/locations-tree-node'
import { ArrowBigRightDash } from 'lucide-react'

export const DevicesMoveToLocationSection = ({
    devices,
    locationsTree,
    customerId,
    selectLocationId,
    onLocationSearch,
    locationSearchStr
}) => {
    const locale = useSelector(state => state.main.locale)
    const theme = useSelector(state => state.main.theme)

    const devicesColumns = [
        {
            key: 'name',
            label: locale.common.name,
            sortable: true,
            dataType: 'string',
            width: 1.5,
            maxWidth: 100,
            render: ({ rowData }) => {
                return rowData.name
            }
        },
        {
            key: 'serial_number',
            label: locale.locations.deviceSerial,
            sortable: true,
            dataType: 'string',
            width: 1,
            maxWidth: 100,
            render: ({ rowData }) => rowData.serial_number
        },
        {
            key: 'location_name',
            label: locale.devices.location,
            sortable: true,
            dataType: 'string',
            width: 1.5,
            maxWidth: 140,
            render: ({ rowData, cellData }) => rowData.location_name
        }
    ]

    const treeRef = useRef(null)
    const treeUtils = useTreeUtils(locationsTree)

    const renderTreeNode = props => (
        <LocationsTreeNode
            search={locationSearchStr}
            actionDisabled={true}
            onLocationPress={selectLocationId}
            locale={locale}
            // rightSlot={location => <LocationDevicesDot location={location} />}
            theme={theme}
            withoutDevicesAmount={true}
            {...props}
        />
    )

    return (
        <div
            style={{
                height: 400,
                display: 'flex'
            }}>
            <div
                style={{
                    height: 400,
                    flex: 1
                }}>
                <TableVirtualized
                    data={devices}
                    columns={devicesColumns}
                    disableHeader={true}
                />
            </div>
            <div
                style={{
                    height: 400,
                    display: 'flex',
                    alignItems: 'center'
                }}>
                <ArrowBigRightDash
                    size={32}
                    color={theme.primary}
                    style={{
                        marginRight: 10,
                        marginLeft: 10
                    }}
                />
            </div>
            <div
                style={{
                    height: 400,
                    flex: 1
                }}>
                <LocationsTree
                    // currentLocation={id}
                    treeRef={treeRef}
                    onSearch={onLocationSearch}
                    treeUtils={treeUtils}
                    renderTreeNode={renderTreeNode}
                    emptyText={locale.locations.noLocationsForResponsible}
                    isInMoveDevicesModal={true}
                    searchStr={locationSearchStr}
                />
            </div>
        </div>
    )
}
